import { useState } from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Grid from '@mui/material/Grid'
import { useAuth } from '../App'
import EmailIcon from '@mui/icons-material/Email'
import { InputAdornment } from '@mui/material'
import { useTranslation } from 'react-i18next'
import backgroundLog from '../assets/backlog.svg'

const SendReset = () => {
  const [email, setEmail] = useState('')
  const auth = useAuth()
  const { t } = useTranslation()
  return (
    <Fade in timeout={300}>
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundAttachment: 'fixed',
        backgroundImage: `url(${backgroundLog})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundColor: 'transparent',
        minHeight: '100vh'
      }}
    >
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={12}
            item
            sx={{
              maxWidth: '512px',
              backdropFilter: 'blur(4px)',
              borderRadius: 4,
              padding: 2,
              margin: 2,
              color: (theme) =>
                theme.palette.mode === 'dark'
                  ? '#f8f8f8'
                  : 'rgba(0, 0, 0, 0.54)',
              backgroundColor: 'background.default'
            }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="stretch"
                sx={{ padding: 1 }}
              >
                <Grid item sx={{ marginTop: 6, marginBottom: 6 }}>
                  <Grid
                    container
                    direction="column"
                    justifyContent="space-between"
                    alignItems="flex-start"
                  >
                    <Box
                      fontWeight="fontWeightBold"
                      fontSize="h6.fontSize"
                      textAlign="left"
                    >
                      {t('sendReset.title', 'Forgot password?')}
                    </Box>
                    <Box fontSize="caption.fontSize" textAlign="left">
                      {t('sendReset.description', "Please enter your email address, we'll send you instructions to help reset your password")}
                    </Box>
                  </Grid>
                </Grid>
                <Box component="form" noValidate autoComplete="off">
                  <TextField
                    fullWidth
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    name="mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="john.doe@gmail.com"
                    InputProps={{
                      sx: { borderRadius: 2 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon />
                        </InputAdornment>
                      )
                    }}
                  />

                  <Grid item sx={{ marginBottom: 2, marginTop: 2 }}>
                    <Button
                      sx={{
                        minHeight: 48,
                        borderRadius: 4,
                      }}
                      fullWidth
                      onClick={() => auth?.sendReset(email)}
                      variant="contained"
                      size="large"
                    >
                      {t('sendReset.submit', 'Send reset instructions')}
                    </Button>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    </Fade>
  )
}
export default SendReset
